/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
==========================================================================================*/

export default [
  {
    url: '/dashboard',
    name: 'Dashboard',
    slug: 'dashboard',
    icon: 'fa-house-user',
    i18n: 'general.dashboard'
  },
  {
    url: '/invoices',
    name: 'Invoices',
    slug: 'invoices',
    icon: 'fa-file-invoice-dollar',
    i18n: 'invoices.my_invoices'
  },
  {
    url: '/services',
    name: 'Services',
    slug: 'services',
    icon: 'fa-notes-medical',
    i18n: 'services.rendered_services'
  },
  {
    url: '/chat',
    name: 'Chat',
    slug: 'chat',
    icon: 'fa-comments',
    i18n: 'chats.chats'
  },
  {
    url: '/reservations',
    name: 'Reservations',
    slug: 'reservations',
    icon: 'fa-calendar-alt',
    i18n: 'reservation.reservations'
  },
  //=============================================
  //Case Manager Section
  //=============================================
  {
    header: 'Case Manager',
    icon: 'PackageIcon',
    i18n: 'case_manager.case_manager',
    items: [
      {
        url: { name: 'case-manager-invoice-list' },
        name: 'Case Manager Invoices',
        slug: 'case-manager-invoices',
        icon: 'fa-file-invoice-dollar',
        i18n: 'invoices.my_invoices'
      },
      {
        url: { name: 'case-manager-service-list' },
        name: 'Case Manager Services',
        slug: 'case-manager-services',
        icon: 'fa-notes-medical',
        i18n: 'services.rendered_services'
      }
    ]
  },
  //=============================================
  //Employee Section
  //=============================================
  {
    header: 'Employee Jobs',
    icon: 'PackageIcon',
    i18n: 'employees.jobs',
    items: [
      {
        url: { name: 'employee-shifts-list' },
        name: 'Employee Shifts',
        slug: 'employee-shifts',
        icon: 'fa-calendar-alt',
        i18n: 'employees.shifts'
      },
      {
        url: { name: 'employee-reserves' },
        name: 'Employee Reserves',
        slug: 'employee-reserves',
        icon: 'fa-calendar-alt',
        i18n: 'reservation.reserves_calender'
      },
      {
        url: { name: 'employee-request-list' },
        name: 'Employee Requests',
        slug: 'employee-requests',
        icon: 'fa-clipboard-list',
        i18n: 'employees.requests'
      },
      {
        url: { name: 'employee-invoice-list' },
        name: 'Employee Invoices',
        slug: 'employee-invoices',
        icon: 'fa-file-invoice-dollar',
        i18n: 'invoices.customer_invoices'
      }
    ]
  },
  //=============================================
  //Manager Section
  //=============================================
  {
    header: 'Business',
    icon: 'PackageIcon',
    i18n: 'businesses.business',
    items: [
      {
        url: { name: 'business-employee-list' },
        name: 'Employees',
        slug: 'employees',
        icon: 'fa-users',
        i18n: 'employees.employees'
      },
      {
        url: { name: 'business' },
        name: 'Places',
        slug: 'places',
        icon: 'fa-map-marked-alt',
        i18n: 'places.places'
      },
      {
        url: { name: 'business-invoice-list' },
        name: 'Invoices',
        slug: 'invoices',
        icon: 'fa-file-invoice-dollar',
        i18n: 'invoices.personnel_invoices'
      },
      {
        url: { name: 'business-payment-list' },
        name: 'Payments',
        slug: 'payments',
        icon: 'fa-file-invoice-dollar',
        i18n: 'payments.payments'
      }
    ]
  },
  //=============================================
  //Admin Section
  //=============================================
  {
    header: 'Admin',
    i18n: 'system.admin',
    items: [
      {
        i18n: 'admin.pending_list',
        submenu: [
          {
            url: { name: 'admin-business-pending' },
            name: 'Pending Businesses',
            slug: 'pending-businesses',
            icon: 'fa-laptop-medical',
            i18n: 'businesses.businesses'
          },
          {
            url: { name: 'admin-document-pending' },
            name: 'Pending Documents',
            slug: 'pending-documents',
            icon: 'fa-file',
            i18n: 'documents.documents'
          }
        ]
      },
      {
        url: { name: 'admin-service-pricing' },
        name: 'Services Pricing',
        slug: 'service-pricing',
        icon: 'fa-money-bill-alt',
        i18n: 'admin.services_pricing'
      },
      {
        url: { name: 'admin-invoice-list' },
        name: 'Invoice List',
        slug: 'invoice-list',
        icon: 'fa-file-invoice-dollar',
        i18n: 'invoices.invoice_list'
      },
      {
        url: '/reservation/resources',
        name: 'Reservation-resource-list',
        slug: 'reservation-resource-list',
        icon: 'fa-calendar-alt',
        i18n: 'reservation.reservations'
      }
    ]
  },
  //=============================================
  //System Section
  //=============================================
  {
    header: 'System',
    icon: 'PackageIcon',
    i18n: 'system.system',
    items: [
      // {
      //   url: '/system/roles',
      //   name: 'Roles',
      //   slug: 'roles',
      //   i18n: 'system.roles.roles'
      // },
      // {
      //   url: '/system/enums',
      //   name: 'Enums',
      //   slug: 'enums',
      //   i18n: 'system.enums'
      // },
      // {
      //   url: '/system/configs',
      //   name: 'Configs',
      //   slug: 'configs',
      //   i18n: 'system.configs'
      // },
      {
        url: '/system/users',
        name: 'Users',
        slug: 'users',
        i18n: 'system.users'
      },
      {
        url: '/system/businesses',
        name: 'Businesses',
        slug: 'businesses',
        i18n: 'system.businesses'
      },
      {
        url: '/system/comments',
        name: 'Comments',
        slug: 'comments',
        i18n: 'comments.comments'
      }
    ]
  },
  //=============================================
  //Health Service Section
  //=============================================
  {
    header: 'Health Service',
    icon: 'MoreHorizontalIcon',
    i18n: 'health_services.health_services',
    items: [
      //=============================================
      //Doctors Items
      //=============================================
      {
        url: null,
        name: 'Doctors',
        icon: 'fa-bars',
        i18n: 'places.categories.doctors',
        submenu: [
          {
            url: '/health-service/doctors/general-doctor',
            name: 'General Doctor',
            icon: 'fa-stethoscope',
            slug: 'health-service-doctors-general-doctor',
            i18n: 'places.subjects.general_doctor'
          },
          {
            url: '/health-service/doctors/specialist-doctor',
            name: 'specialist Doctor',
            icon: 'fa-user-md',
            slug: 'health-service-doctors-specialist-doctor',
            i18n: 'places.subjects.specialist_doctor'
          },
          {
            url: '/health-service/doctors/traditional-medicine',
            name: 'Traditional Medicine',
            icon: 'fa-seedling',
            slug: 'health-service-doctors-traditional-medicine',
            i18n: 'places.subjects.traditional_medicine'
          },
          {
            url: '/health-service/doctors/occupational-medicine',
            name: 'Occupational Medicine',
            icon: 'fa-user-md',
            slug: 'health-service-doctors-occupational-medicine',
            i18n: 'places.subjects.occupational_medicine'
          }
        ]
      },
      {
        //=============================================
        //Pack Items
        //=============================================
        url: null,
        name: 'Pack',
        icon: 'fa-bars',
        i18n: 'places.categories.pack',
        submenu: [
          {
            url: '/health-service/pack/coronavirus',
            name: 'Coronavirus',
            slug: 'health-service-pack-coronavirus',
            icon: 'fa-virus',
            i18n: 'places.subjects.coronavirus'
          },
          {
            url: '/health-service/pack/elderly',
            name: 'Elderly',
            slug: 'health-service-pack-elderly',
            icon: 'fa-file',
            i18n: 'places.subjects.elderly'
          },
          {
            url: '/health-service/pack/incurable-patient',
            name: 'IncurablePatient',
            slug: 'health-service-pack-incurable-patient',
            icon: 'fa-file',
            i18n: 'places.subjects.incurable_patient'
          },
          {
            url: '/health-service/pack/newborn-care',
            name: 'NewbornCare',
            slug: 'health-service-pack-newborn-care',
            icon: 'fa-file',
            i18n: 'places.subjects.newborn_care'
          },
          {
            url: '/health-service/pack/pregnancy-period',
            name: 'PregnancyPeriod',
            slug: 'health-service-pack-pregnancy-period',
            icon: 'fa-file',
            i18n: 'places.subjects.pregnancy_period'
          },
          {
            url: '/health-service/pack/child-birth-at-home',
            name: 'ChildBirthAtHome',
            slug: 'health-service-pack-child-birth-at-home',
            icon: 'fa-file',
            i18n: 'places.subjects.child_birth_at_home'
          },
          {
            url: '/health-service/pack/recovery-period-after-surgery',
            name: 'RecoveryPeriodAfterSurgery',
            slug: 'health-service-pack-recovery-period-after-surgery',
            icon: 'fa-file',
            i18n: 'places.subjects.recovery_period_after_surgery'
          },
          {
            url: '/health-service/pack/icu-care-at-home',
            name: 'IcuCareAtHome',
            slug: 'health-service-pack-icu-care-at-home',
            icon: 'fa-file',
            i18n: 'places.subjects.icu_care_at_home'
          },
          {
            url: '/health-service/pack/case-manager',
            name: 'CaseManager',
            slug: 'health-service-pack-case-manager',
            icon: 'fa-file',
            i18n: 'places.subjects.case_manager'
          }
        ]
      },

      {
        //=============================================
        //Tourism Items
        //=============================================
        url: null,
        name: 'Tourism',
        icon: 'fa-bars',
        i18n: 'places.categories.tourism',
        submenu: [
          {
            url: '/health-service/tourism/medical',
            name: 'Medical',
            slug: 'health-service-tourism-medical',
            i18n: 'places.subjects.medical'
          },
          {
            url: '/health-service/tourism/complementary',
            name: 'Complementary',
            slug: 'health-service-tourism-complementary',
            i18n: 'places.subjects.complementary'
          },
          {
            url: '/health-service/tourism/licensing',
            name: 'Licensing',
            slug: 'health-service-tourism-licensing',
            i18n: 'places.subjects.licensing'
          },
          {
            url: '/health-service/tourism/transportation',
            name: 'Transportation',
            slug: 'health-service-tourism-transportation',
            i18n: 'places.subjects.transportation'
          },
          {
            url: '/health-service/tourism/ancillary',
            name: 'Ancillary',
            slug: 'health-service-tourism-ancillary',
            i18n: 'places.subjects.ancillary'
          },
          {
            url: '/health-service/tourism/accommodation',
            name: 'Accommodation',
            slug: 'health-service-tourism-accommodation',
            i18n: 'places.subjects.accommodation'
          }
        ]
      },
      {
        //=============================================
        //Nursing Items
        //=============================================
        url: null,
        name: 'Nursing',
        icon: 'fa-bars',
        i18n: 'places.categories.nursing',
        submenu: [
          {
            url: '/health-service/nursing/injection',
            name: 'Injection',
            icon: 'fa-syringe',
            slug: 'health-service-nursing-injection',
            i18n: 'places.subjects.injection'
          },
          {
            url: '/health-service/nursing/dressing',
            name: 'Dressing',
            icon: 'fa-band-aid',
            slug: 'health-service-nursing-dressing',
            i18n: 'places.subjects.dressing'
          },
          {
            url: '/health-service/nursing/catheterization',
            name: 'Catheterization',
            slug: 'health-service-nursing-catheterization',
            i18n: 'places.subjects.catheterization'
          },
          {
            url: '/health-service/nursing/professional-caring',
            name: 'Professional Caring',
            icon: 'fa-medkit',
            slug: 'health-service-nursing-professional-caring',
            i18n: 'places.subjects.professional_caring'
          },
          {
            url: '/health-service/nursing/special-caring',
            name: 'Special Caring',
            slug: 'health-service-nursing-special-caring',
            i18n: 'places.subjects.special_caring'
          },
          {
            url: '/health-service/nursing/ambulance',
            name: 'Ambulance',
            icon: 'fa-ambulance',
            slug: 'health-service-nursing-ambulance',
            i18n: 'places.subjects.ambulance'
          }
        ]
      },
      //=============================================
      //Drug And Cosmetic Items
      //=============================================
      {
        url: null,
        name: 'Drug And Cosmetic',
        icon: 'fa-bars',
        i18n: 'places.categories.drug_and_cosmetic',
        submenu: [
          {
            url: '/health-service/drug-and-cosmetic/drug',
            name: 'Drug',
            icon: 'fa-pills',
            slug: 'health-service-drug-and-cosmetic-drug',
            i18n: 'places.subjects.drug'
          },
          {
            url: '/health-service/drug-and-cosmetic/cosmetic',
            name: 'Cosmetic',
            icon: 'fa-pump-soap',
            slug: 'health-service-drug-and-cosmetic-cosmetic',
            i18n: 'places.subjects.cosmetic'
          },
          {
            url: '/health-service/drug-and-cosmetic/herbal-medicine',
            name: 'Herbal Medicine',
            icon: 'fa-mortar-pestle',
            slug: 'health-service-drug-and-cosmetic-herbal-medicine',
            i18n: 'places.subjects.herbal_medicine'
          },
          {
            url: '/health-service/drug-and-cosmetic/medicinal-plant',
            name: 'Medicinal Plant',
            icon: 'fa-seedling',
            slug: 'health-service-drug-and-cosmetic-medicinal-plant',
            i18n: 'places.subjects.medicinal_plant'
          }
        ]
      },
      //=============================================
      //Equipment Items
      //=============================================
      {
        url: null,
        name: 'Equipment',
        icon: 'fa-bars',
        i18n: 'places.categories.equipment',
        submenu: [
          {
            url: '/health-service/equipment/rent',
            name: 'Rent',
            icon: 'fa-shopping-cart',
            slug: 'health-service-equipment-rent',
            i18n: 'places.subjects.rent'
          }
          /*{
            url: '/health-service/equipment/buy',
            name: 'Buy',
            icon: 'fa-shopping-basket',
            slug: 'health-service-equipment-buy',
            i18n: 'places.subjects.buy'
          }*/
        ]
      },
      //=============================================
      //Imaging Items
      //=============================================
      {
        url: null,
        name: 'Imaging',
        icon: 'fa-bars',
        i18n: 'places.categories.imaging',
        submenu: [
          {
            url: '/health-service/imaging/ecg',
            name: 'Ecg',
            icon: 'fa-heartbeat',
            slug: 'health-service-imaging-ecg',
            i18n: 'places.subjects.ecg'
          },
          {
            url: '/health-service/imaging/brain-tape',
            name: 'Brain Tape',
            icon: 'fa-brain',
            slug: 'health-service-imaging-brain-tape',
            i18n: 'places.subjects.brain_tape'
          },
          {
            url: '/health-service/imaging/sonography',
            name: 'Sonography',
            slug: 'health-service-imaging-sonography',
            i18n: 'places.subjects.sonography'
          },
          {
            url: '/health-service/imaging/portable-radiography',
            name: 'Portable Radiography',
            icon: 'fa-radiation',
            slug: 'health-service-imaging-portable-radiography',
            i18n: 'places.subjects.portable_radiography'
          }
        ]
      },
      //=============================================
      //Laboratory Items
      //=============================================
      {
        url: null,
        name: 'Laboratory',
        icon: 'fa-bars',
        i18n: 'places.categories.laboratory',
        submenu: [
          {
            url: '/health-service/laboratory/check-up',
            name: 'Check Up',
            icon: 'fa-vials',
            slug: 'health-service-laboratory-check-up',
            i18n: 'places.subjects.check_up'
          },
          {
            url: '/health-service/laboratory/corona-test',
            name: 'Corona Test',
            icon: 'fa-vials',
            slug: 'health-service-laboratory-corona-test',
            i18n: 'places.subjects.corona_test'
          },
          {
            url: '/health-service/laboratory/medical-diagnostic-laboratory',
            name: 'Medical Diagnostic Laboratory',
            icon: 'fa-vial',
            slug: 'health-service-laboratory-medical-diagnostic-laboratory',
            i18n: 'places.subjects.medical_diagnostic_lab'
          }
        ]
      },
      //=============================================
      //Consulting Items
      //=============================================
      {
        url: null,
        name: 'Consulting',
        icon: 'fa-bars',
        i18n: 'places.categories.consulting',
        submenu: [
          {
            url: '/health-service/consulting/doctor-general',
            name: 'Doctor General',
            icon: 'fa-stethoscope',
            slug: 'health-service-consulting-doctor-general',
            i18n: 'places.subjects.doctor_general'
          },
          {
            url: '/health-service/consulting/doctor-specialist',
            name: 'Doctor Specialist',
            icon: 'fa-stethoscope',
            slug: 'health-service-consulting-doctor-specialist',
            i18n: 'places.subjects.doctor_specialist'
          },
          {
            url: '/health-service/consulting/doctor-traditional-medicine',
            name: 'Doctor Traditional Medicine',
            icon: 'fa-seedling',
            slug: 'health-service-consulting-doctor-traditional-medicine',
            i18n: 'places.subjects.doctor_traditional_medicine'
          },
          {
            url: '/health-service/consulting/dentistical',
            name: 'Dentistical',
            icon: 'fa-tooth',
            slug: 'health-service-consulting-dentistical',
            i18n: 'places.subjects.dentistical'
          },
          {
            url: '/health-service/consulting/nutrition',
            name: 'Nutrition',
            icon: 'fa-drumstick-bite',
            slug: 'health-service-consulting-nutrition',
            i18n: 'places.subjects.nutrition'
          },
          {
            url: '/health-service/consulting/nursing',
            name: 'Nursing And Care',
            icon: 'fa-user-nurse',
            slug: 'health-service-consulting-nursing',
            i18n: 'places.subjects.nursing'
          },
          {
            url: '/health-service/consulting/medicinal',
            name: 'Medicinal',
            icon: 'fa-pills',
            slug: 'health-service-consulting-medicinal',
            i18n: 'places.subjects.medicinal'
          },
          {
            url: '/health-service/consulting/psychology',
            name: 'Psychology',
            icon: 'fa-user-friends',
            slug: 'health-service-consulting-psychology',
            i18n: 'places.subjects.psychology'
          },
          {
            url: '/health-service/consulting/sanitary',
            name: 'Sanitary',
            icon: 'fa-pump-soap',
            slug: 'health-service-consulting-sanitary',
            i18n: 'places.subjects.sanitary'
          },
          {
            url: '/health-service/consulting/insurance',
            name: 'Insurance',
            icon: 'fa-umbrella',
            slug: 'health-service-consulting-insurance',
            i18n: 'places.subjects.insurance'
          }
        ]
      },
      //=============================================
      //Accompanying The Patient Items
      //=============================================
      {
        url: null,
        name: 'AccompanyingThePatient',
        icon: 'fa-bars',
        i18n: 'places.categories.accompanying_the_patient',
        submenu: [
          {
            url: '/health-service/accompanying-the-patient/hospitals-and-clinic',
            name: 'Hospitals AndClinic',
            icon: 'fa-hospital',
            slug: 'health-service-accompanying-the-patient-hospitals-and-clinic',
            i18n: 'places.subjects.hospitals_and_clinic'
          },
          {
            url: '/health-service/accompanying-the-patient/para-clinic',
            name: 'Para Clinic',
            icon: 'fa-hospital',
            slug: 'health-service-accompanying-the-patient-para-clinic',
            i18n: 'places.subjects.para_clinic'
          },
          {
            url: '/health-service/accompanying-the-patient/para-medical',
            name: 'Para Medical',
            icon: 'fa-hospital',
            slug: 'health-service-accompanying-the-patient-para-medical',
            i18n: 'places.subjects.para_medical'
          }
        ]
      }
    ]
  }
]
